

/************ ANNNOUNCEMENT BAR  STICKY VIEW START **************/
const checkInterval = setInterval(() => {
  const childElements = document.querySelector('.announcement-bar');
  const mobileChildElement = document.querySelector('.announcement_mobile');
  const hide_PageContainer_Overflow = document.getElementById("PageContainer");

  function getFixedOffsetTop(el) {
    let offsetTop = 0;
    while (el) {
      offsetTop += el.offsetTop;
      el = el.offsetParent;
    }
    return offsetTop;
  }

  const mobileView = getFixedOffsetTop(mobileChildElement);

  if (childElements || mobileChildElement) {
    
    if(hide_PageContainer_Overflow){
      if(window.innerWidth > 750){
        hide_PageContainer_Overflow.style.overflow = 'initial';
      }
    }
    
    window.addEventListener('scroll', () => {
      // Get scroll position
      const scrollY = window.scrollY;
    
      if (scrollY > 10) {
        childElements.classList.add('section--sticky-announcementbar');
      } else {
        childElements.classList.remove('section--sticky-announcementbar');
      }
      if(mobileChildElement){
        if (scrollY > mobileView) {
          mobileChildElement.classList.add('section--sticky-announcementbar');
        } else {
          mobileChildElement.classList.remove('section--sticky-announcementbar');
        }
      }
    });
    
    clearInterval(checkInterval); // Stop checking
  } else {
    console.log("Waiting for element...");
    setTimeout(() => {
      clearInterval(checkInterval); // Stop checking
    }, 10000);
  }
}, 500);



// ------- new for mobile 

 const checkIntervals = setInterval(() => {

  const childElements = document.querySelector('.announcement-bar');
  const mobileChildElements = document.querySelector('.announcement_mobile_new');
  const hide_PageContainer_Overflows = document.getElementById("PageContainer");

  function getFixedOffsetTops(el) {
    let offsetTop = 0;
    while (el) {
      offsetTop += el.offsetTop;
      el = el.offsetParent;
    }
    return offsetTop;
  }

  if (childElements || mobileChildElements) {

    if (hide_PageContainer_Overflows && window.innerWidth > 750) {
      hide_PageContainer_Overflows.style.overflow = 'initial';
    }

    const mobileViews = mobileChildElements 
      ? getFixedOffsetTops(mobileChildElements) 
      : 0;

    window.addEventListener('scroll', () => {

      const scrollYs = window.scrollY;

      // Desktop
      if (childElements) {
        if (scrollYs > 10) {
          childElements.classList.add('section--sticky-announcementbar');
        } else {
          childElements.classList.remove('section--sticky-announcementbar');
        }
      }

      // Mobile
      if (mobileChildElements) {
        if (scrollYs > mobileViews) {
          mobileChildElements.classList.add('section--sticky-announcementbar');
        } else {
          mobileChildElements.classList.remove('section--sticky-announcementbar');
        }
      }

    });

    clearInterval(checkIntervals);

  } else {
    console.log("Waiting for element...");
  }

}, 500);

/************ ANNNOUNCEMENT BAR  STICKY VIEW END **************/


/************ DISCOUNT VIEW START **************/
if (window.innerWidth < 749) {
  const checkDiscountInterval = setInterval(() => {
    const select_discount = document.querySelectorAll(".gf_pq-discount-selector");
    const gryffeditor_div = document.querySelector(".gryffeditor");
    
    if (select_discount.length > 0 && gryffeditor_div) {
      gryffeditor_div.prepend(select_discount[0]);
      setTimeout(() => {
        const gf_discount = gryffeditor_div.querySelector(".gf_pq-discount");
        if (gf_discount.firstChild) {
          gf_discount.removeChild(gf_discount.firstChild);
        }
        const lastChild = gf_discount.lastElementChild;
        if (lastChild) {
          lastChild.textContent = "OFF"; // Appends text
        }
      }, 500);
      clearInterval(checkDiscountInterval); // Stop checking
    } else {
      console.log("Waiting for element...");
      setTimeout(() => {
        clearInterval(checkDiscountInterval); // Stop checking
      }, 10000);
    }
  }, 500);
} else {
  const checkExistingDiscountInterval = setInterval(() => {
    const gf_product_prices = document.querySelector(".gf_product-prices");
  
    if (gf_product_prices) {
      const select_discount = gf_product_prices.querySelector(".gf_pq-discount-selector");
      gf_product_prices.setAttribute("id", "gf--discount_prices--value");
      select_discount.setAttribute("id", "gf--discount-value");
      setTimeout(() => {
        const gf_discount = select_discount.querySelector(".gf_pq-discount");
        if (gf_discount.firstChild) {
          gf_discount.removeChild(gf_discount.firstChild);
        }
        const lastChild = gf_discount.lastElementChild;
        if (lastChild) {
          lastChild.textContent = "OFF"; // Appends text
        }
      }, 500);
      clearInterval(checkExistingDiscountInterval); // Stop checking
    } else {
      console.log("Waiting for element...");
      setTimeout(() => {
        clearInterval(checkExistingDiscountInterval); // Stop checking
      }, 10000);
    }
  }, 500);
}
/************ DISCOUNT VIEW END **************/


/************ CONTINUOUS BUTTON ON CART DRAWER VIEW START **************/
let buttonAppended = false;

function appendTheButton() {
  const upCart = document.getElementById("upCart");

  if (!upCart || !upCart.shadowRoot) return;

  const upcartPopup = upCart.shadowRoot.getElementById("UpcartPopup");
  const cartPopup = upcartPopup?.querySelector("#CartPopup");

  const cart_empty = cartPopup?.querySelector(".styles_CartPreview__empty__");

  if (cart_empty && !cart_empty.querySelector(".cart-shopping--link--wrapper")) {
    const cart_empty_h3 = cart_empty.querySelector("h3");
    cart_empty.style.flexDirection = "column";
    cart_empty_h3 && (cart_empty_h3.style.margin = "20px");

    const continuous_shopping_button = document.createElement("div");
    continuous_shopping_button.className = "cart-shopping--link--wrapper";
    continuous_shopping_button.innerHTML = `
      <a href="/collections/frontpage" class="shopping--link button-link" alt="collection" style="display: inline-block; padding: 10px 20px; background-color: #007bff; color: white; text-decoration: none; border-radius: 5px; font-size: 16px; font-weight: bold; border: none; cursor: pointer;">
        <span>Continue Shopping</span>
      </a>
    `;

    cart_empty.appendChild(continuous_shopping_button);
    buttonAppended = true;
    console.log("✅ Button appended");
  }
}

function watchCart() {
  const interval = setInterval(() => {
    if (!buttonAppended) appendTheButton();
  }, 300);

  // Stop after 10 seconds to avoid infinite looping
  setTimeout(() => clearInterval(interval), 10000);
}

// Watch for user actions that might open or update the cart
["click", "keydown", "touchstart"].forEach((eventType) => {
  document.addEventListener(eventType, () => {
    buttonAppended = false; // reset flag on any interaction
    watchCart();
  });
});

// Optional: Also run on page load in case cart is already open
window.addEventListener("load", () => {
  watchCart();
});


/************ CONTINUOUS BUTTON ON CART DRAWER VIEW END **************/


/************** UPDATE TEXT DATE ON HOME PAGE START **************/
const interval = setInterval(() => {
  const slideShowContent = document.querySelectorAll('.slideshow__text-content');
  const subtitleEl = document.querySelector('.slideshow__subtitle');

  if (slideShowContent.length > 0 && subtitleEl && !subtitleEl.dataset.dateAppended) {
    const today = new Date();

    // Format the date in US (Eastern Time)
    const formattedDate = today.toLocaleDateString('en-US', {
      timeZone: 'America/New_York', // Change this to your desired U.S. time zone
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });

    subtitleEl.textContent += ' ' + formattedDate + '!';
    subtitleEl.dataset.dateAppended = 'true';

    clearInterval(interval);
  }
}, 300);

/************** UPDATE TEXT DATE ON HOME PAGE END **************/


/************** UPDATE CART DRAWER ON COLLECTION PAGE START **************/
window.addEventListener('pageshow', function (event) {
  if (window.location.href.includes('collections')) {
    const isBack = event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    const hasParam = window.location.href.includes('reloaded=true');

    if (isBack && !hasParam) {
      const newUrl = window.location.href + (window.location.href.includes('?') ? '&' : '?') + 'reloaded=true';
      window.location.replace(newUrl);
    }
  }
});
/************** UPDATE CART DRAWER ON COLLECTION PAGE END **************/


/************** HIDE AND SHOW STICKY CART ICON START **************/
let lastScrollTop = 0;
const startTime = Date.now(); // Declare this before setInterval

const scrollInterval = setInterval(() => {
  const header_view = document.getElementById('shopify-section-header');
  const satcb_cart__icon = document.getElementById('satcb_sticky_cart');

  if (header_view && satcb_cart__icon) {
    clearInterval(scrollInterval); // Stop checking once found
    satcb_cart__icon.classList.add('hide-satcb_sticky_cart');
    window.addEventListener('scroll', () => {
      const headerHeight = header_view.offsetHeight + 50;
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > headerHeight) {
        // console.log("Header or sticky: ", headerHeight, currentScroll);
        satcb_cart__icon.classList.remove('hide-satcb_sticky_cart');
      } else if(currentScroll < headerHeight) {
        satcb_cart__icon.classList.add('hide-satcb_sticky_cart');
      }
    });
  } else if (Date.now() - startTime > 15000) {
    //console.warn("Header or sticky cart not found within 15s.");
    clearInterval(scrollInterval);
  }
}, 200);

/************** HIDE AND SHOW STICKY CART ICON END **************/


/************** MAKE PRODUCT IMAGE CLICKABLE START **************/
if (window.innerWidth < 640) {
  const checkLinkInterval = setInterval(() => {
    const product_link = document.getElementById("product-thumbnail--link");

    if (product_link) {
      clearInterval(checkLinkInterval); // Stop checking once found

      product_link.addEventListener("click", () => {
        const view_link = product_link.getAttribute("data-link");
        if (view_link) {
          window.location.href = view_link;
        }
      });
    }
  }, 200); // Check every 200ms

  // Force stop after 10 seconds
  setTimeout(() => {
    clearInterval(checkLinkInterval);
  }, 10000);
}
/************** MAKE PRODUCT IMAGE CLICKABLE END **************/


/************** SINGLE PRODUCT RATING START **************/
function scrollToReviewsWhenReady() {
  const reviewsElAnchor = document.querySelector('.scm-reviews--rating');
  const reviewsEl = document.querySelector('.scm-reviews-importer');

  if (reviewsEl && reviewsEl.offsetHeight > 40) {
    //reviewsEl.scrollIntoView({ behavior: 'smooth' });
    console.log("LINK:", reviewsEl?.offsetHeight);
  } else if (reviewsElAnchor) {
    reviewsElAnchor.setAttribute("href", "javascript:void(0)");
    reviewsElAnchor.style.pointerEvents = "none"; // Corrected property
  }
}

// Use setInterval to retry until the element exists, then stop
const checkAnchorInterval = setInterval(() => {
  const reviewsElAnchor = document.querySelector('.scm-reviews--rating');
  const reviewsEl = document.querySelector('.scm-reviews-importer');
  if(reviewsEl){
    const height = reviewsEl.offsetHeight;
    if (height > 10) {
      clearInterval(checkAnchorInterval); // Stop checking once the element is found
      scrollToReviewsWhenReady();   // Call the scroll function
    }
  }else{
    setTimeout(() => clearInterval(checkAnchorInterval), 15000)
  }
}, 2000); // Check every 500ms
/************** SINGLE PRODUCT RATING END **************/

/************** ADD TO CART QUANTITY HANDLER FUNCTION START **************/
$(document).ready(function () {
  // Unbind previous event handlers if any to prevent double-firing
  $(document).off('click', '.qtyplus');
  $(document).off('click', '.qtyminus');

  // Plus button
  $(document).on('click', '.qtyplus', function (e) {
    e.preventDefault();
    const fieldName = $(this).attr('field');
    const input = $('input[name=' + fieldName + ']');
    let currentVal = parseInt(input.val());

    if (!isNaN(currentVal)) {
      input.val(currentVal + 1);
    } else {
      input.val(1);
    }
    });

  // Minus button
  $(document).on('click', '.qtyminus', function (e) {
    e.preventDefault();
    const fieldName = $(this).attr('field');
    const input = $('input[name=' + fieldName + ']');
    let currentVal = parseInt(input.val());

    if (!isNaN(currentVal) && currentVal > 1) {
      input.val(currentVal - 1);
    } else {
      input.val(1); // Always keep it minimum 1
    }
  });
});
/************** ADD TO CART QUANTITY HANDLER FUNCTION START **************/

/************** REMOVE STICKY CART FROM MYSTERY BOX START **************/
if (window.location.href.includes("mystery-gift")) {
  const intervalId = setInterval(() => {
    const stickyAtc = document.getElementById("md-sticky-atc");

    if (stickyAtc) {
      stickyAtc.style.opacity = "0";
      stickyAtc.style.visibility = "hidden";
      clearInterval(intervalId);
    } else {
      setTimeout(() => clearInterval(intervalId), 5000);
    }
  }, 100);
}
/************** REMOVE STICKY CART FROM MYSTERY BOX END **************/


/************** MAIN AND STICKY SECTION VARIANT SYNCONIZE START **************/
if(window.location.href.includes("products")){
  const intervalCheckVariant = setInterval(() => {
    const select_product__variant = document.querySelectorAll(".swatch-element .track--slick-slide--value");

    if (select_product__variant.length > 0) {
      select_product__variant.forEach((variant, i) => {
        variant.addEventListener("change", () => {
          setTimeout(() => {
            const selected_variant_id = window.location.href.split("variant=");
            const product_variant_input = document.querySelector("#md-sticky-atc .product-variant-id");
            const new_select_variants = document.querySelectorAll("#md-sticky-atc .product-variant--option");
            console.log("Slect variant: ", selected_variant_id)
            new_select_variants.forEach((item, i) => {
              const variant_ID = item.getAttribute("data-variantid");
              if(parseInt(selected_variant_id[1]) === parseInt(variant_ID)){
                const {variantTitle, variantid} = item.dataset;
                const variants_arr = variantTitle.split("/").map(s => s.trim());

                product_variant_input.value = variantid;
                // Get the select element
                const variantSelector = document.querySelectorAll("#md-sticky-atc .product-form__selector--variants");
                const selectFirstElement = variantSelector[0]?.querySelector("#SingleOptionSelector-0") || null;
                const selectSecondElement = variantSelector[1]?.querySelector("#SingleOptionSelector-1") || null;
                const selectThirdElement = variantSelector[2]?.querySelector("#SingleOptionSelector-2") || null;

                //console.log(selectFirstElement, selectSecondElement, selectThirdElement, item.dataset);

                if(variantSelector.length == variants_arr.length){
                  if(selectFirstElement){
                    const selectFirstOptions = selectFirstElement.options;
                    for (let j = 0; j < selectFirstOptions.length; j++) {
                      if (selectFirstOptions[j].value === variants_arr[0]) {
                        selectFirstOptions[j].setAttribute("selected", "selected");
                        selectFirstElement.dispatchEvent(new Event("change"));
                      }else{
                        selectFirstOptions[j].removeAttribute("selected");
                      }
                    }
                  }
                  if(selectSecondElement){
                    const selectSecondOptions = selectSecondElement.options;
                    for (let k = 0; k < selectSecondOptions.length; k++) {
                      if (selectSecondOptions[k].value === variants_arr[1]) {
                        selectSecondOptions[k].setAttribute("selected", "selected")
                        selectSecondElement.dispatchEvent(new Event("change"));
                      }else{
                        selectSecondOptions[k].removeAttribute("selected");
                      }
                    }
                  }
                  if(selectThirdElement){
                    const selectThirdOptions = selectThridElement.options;
                    for (let m = 0; m < selectThirdOptions.length; m++) {
                      if (selectThirdOptions[m].value === variants_arr[2]) {
                        selectThirdOptions[m].setAttribute("selected", "selected");
                        selectThirdElement.dispatchEvent(new Event("change"));
                      }else{
                        selectThirdOptions[m].removeAttribute("selected");
                      }
                    }
                  }
                }
              }
            });
            
          }, 1000);
        });
      })
      clearInterval(intervalCheckVariant);
    } else {
      setTimeout(() => clearInterval(intervalCheckVariant), 5000);
    }
  }, 200);
}
/************** MAIN AND STICKY SECTION VARIANT SYNCONIZE END **************/


/************** ADD SCROLL VIEW ON CART DRAWER START **************/
(function () {
  const intervalScrollView = setInterval(() => {
    const up_Cart = document.getElementById("upCart");
    if (!up_Cart || !up_Cart.shadowRoot) return;
  
    const upcart_Popup = up_Cart.shadowRoot.getElementById("UpcartPopup");
    const cart_Popup = upcart_Popup?.querySelector("#CartPopup");
    if(cart_Popup){
      let addScrollInCart = cart_Popup.querySelector(".upcart-cart-body");
      
      if(addScrollInCart){
        let upcart_footer = cart_Popup.querySelector(".upcart-footer");
        let upcart_footer_button = upcart_footer.querySelector(".styles_Footer__checkoutButton__");
        addScrollInCart.style.scrollbarWidth = "thin";
        addScrollInCart.style.scrollbarColor = "#8c8989 #ffffff";
        addScrollInCart.style.overflowY = "scroll";

        //console.log("Cart: ", upcart_footer_button);
          hhhhhhhhhhhh
        let payment_badge_icons = `<div class="payment-badges-block 11" style="margin-top: 0.6rem; margin-bottom: 0.2rem;">
            <ul class="payment-badges" role="list" style="display: flex; width: 100%; justify-content: center; align-items: center; gap: 15px; list-style: none; padding-left: 0;">          
              <li class="list-payment__item">
                <svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="pi-american_express" viewBox="0 0 38 24" width="38" height="24"><title id="pi-american_express">American Express</title><path fill="#000" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3Z" opacity=".07"></path><path fill="#006FCF" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32Z"></path><path fill="#FFF" d="M22.012 19.936v-8.421L37 11.528v2.326l-1.732 1.852L37 17.573v2.375h-2.766l-1.47-1.622-1.46 1.628-9.292-.02Z"></path><path fill="#006FCF" d="M23.013 19.012v-6.57h5.572v1.513h-3.768v1.028h3.678v1.488h-3.678v1.01h3.768v1.531h-5.572Z"></path><path fill="#006FCF" d="m28.557 19.012 3.083-3.289-3.083-3.282h2.386l1.884 2.083 1.89-2.082H37v.051l-3.017 3.23L37 18.92v.093h-2.307l-1.917-2.103-1.898 2.104h-2.321Z"></path><path fill="#FFF" d="M22.71 4.04h3.614l1.269 2.881V4.04h4.46l.77 2.159.771-2.159H37v8.421H19l3.71-8.421Z"></path><path fill="#006FCF" d="m23.395 4.955-2.916 6.566h2l.55-1.315h2.98l.55 1.315h2.05l-2.904-6.566h-2.31Zm.25 3.777.875-2.09.873 2.09h-1.748Z"></path><path fill="#006FCF" d="M28.581 11.52V4.953l2.811.01L32.84 9l1.456-4.046H37v6.565l-1.74.016v-4.51l-1.644 4.494h-1.59L30.35 7.01v4.51h-1.768Z"></path></svg>

              </li>
              <li class="list-payment__item">
                <svg class="icon icon--full-color" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" x="0" y="0" width="38" height="24" viewBox="0 0 165.521 105.965" xml:space="preserve" aria-labelledby="pi-apple_pay"><title id="pi-apple_pay">Apple Pay</title><path fill="#000" d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"></path><path fill="#FFF" d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"></path><g><g><path fill="#000" d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"></path><path fill="#000" d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"></path></g><g><path fill="#000" d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"></path><path fill="#000" d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"></path><path fill="#000" d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"></path></g></g></svg>

              </li>
              <li class="list-payment__item">
                <svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-master"><title id="pi-master">Mastercard</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><circle fill="#EB001B" cx="15" cy="12" r="7"></circle><circle fill="#F79E1B" cx="23" cy="12" r="7"></circle><path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"></path></svg>
              </li>
              <li class="list-payment__item">
                <svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"></path><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"></path><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"></path></svg>
              </li>
              <li class="list-payment__item">
                <svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-visa"><title id="pi-visa">Visa</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z" fill="#142688"></path></svg>
              </li>
            </ul>
             <div class="terms" style="margin-top: -0.8rem; margin-bottom: 0.2rem; text-align:center; color:black; font-size:14px;">
  <p class="cart-drawer-message">30 Days Return + Free Shipping</p>
</div>
        </div>
        <p class="cart-drawer-message" style="text-align: center; margin-top: 1rem;">30 Days Return + Free Shipping</p>
        `;

        upcart_footer_button.insertAdjacentHTML("afterend", payment_badge_icons);

        clearInterval(intervalScrollView);

      }
    }else{
      setTimeout(() => clearInterval(intervalScrollView), 10000);
    }
  }, 100);
})();
/************** ADD SCROLL VIEW ON CART DRAWER END **************/